<template>
  <v-container grid-list-md pa-0 ma-2 pb-5 style="max-width: calc(100% - 16px)">
    <v-expand-transition>
      <v-layout v-show="selectedInitiativesUpdate.length < 1" row wrap>
        <v-flex xs12 sm6 md3 lg2>
          <SelectCreditors
            ref="creditorComponent"
            :multiple="false"
            :clearable="true"
            :selected="selectedCreditor"
            :active="true"
            @selectedCreditors="handleCreditor"
            @creditorsList="setCreditors"></SelectCreditors>
        </v-flex>
        <v-flex xs12 sm6 md3 lg2>
          <v-text-field
            box
            flat
            success
            label="Pesquisar"
            :clearable="true"
            append-icon="search"
            v-model="searchValue"
            @input="handleSearch">
          </v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md4 lg2>
          <v-select
            v-model="metaCategoryAux"
            :items="categories"
            :clearable="true"
            label="Categorias"
            item-text="name"
            item-value="value"
            @change="handleCategory"
            box
            flat
            success>
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0" style="padding-right: 5px">{{ item.name }}</span>
            </template>
          </v-select>
        </v-flex>

        <v-flex xs12 sm6 md4 lg2>
          <sender-selector
            :items="senders"
            :loading="loadingSenders"
            v-model="senderAux"
            @input="handleSender"></sender-selector>
        </v-flex>

        <v-flex xs12 sm6 md4 lg2>
          <v-select
            v-model="approvedAux"
            :items="templates"
            label="Templates"
            item-text="name"
            item-value="value"
            @change="handleApproved"
            box
            flat
            success>
          </v-select>
        </v-flex>

        <v-flex xs12 sm6 md4 lg2>
          <v-switch
            v-model="showDeactivatedsAux"
            label="Mostrar desativadas"
            @change="handleDeactivated">
          </v-switch>
        </v-flex>
      </v-layout>
    </v-expand-transition>
    <v-expand-transition>
      <v-layout wrap v-show="selectedInitiativesUpdate.length >= 1">
        <span class="ativar" v-show="showDeactivatedsAux">
          <v-btn
            color="accent"
            style="border-radius: 5px"
            @click="handleActivateOrDeactivate(selectedInitiativesUpdate)"
            >Ativar</v-btn
          >
        </span>
        <span class="desativar" v-show="!showDeactivatedsAux">
          <v-btn
            color="accent"
            style="border-radius: 5px"
            @click="handleActivateOrDeactivate(selectedInitiativesUpdate)"
            >Desativar</v-btn
          >
        </span>
        <v-btn
          color="accent"
          style="border-radius: 5px"
          @click="syncSelected(selectedInitiativesUpdate)"
        >
          Sync (meta)
        </v-btn>

        <v-btn
          flat
          icon
          large
          class="my-0 py-0"
          color="accent"
          @click="
            selectedInitiativesUpdate = [];
            selectAllCheckbox = false;
          ">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-layout>
    </v-expand-transition>
    <v-alert :value="error" type="error">
      Erro
      <v-btn @click="getInitiatives()">Tentar novamente</v-btn>
    </v-alert>
    <v-data-table
      :total-items="totalInitiatives"
      :items="initiativesList"
      :disable-initial-sort="true"
      :pagination.sync="pagination"
      :rows-per-page-items="[10, 25, 50, 100]"
      :headers="headers"
      :hide-actions="false"
      :loading="initiaveLoading"
      v-model="selectedInitiativesUpdate"
      class="mb-4"
      @update:pagination="getInitiatives()"
      v-if="!error">
      <template v-slot:items="props">
        <tr style="height: 80px !important" :class="{ 'inactive-row': !props.item.active }">
          <td>
            <v-checkbox v-model="props.selected" hide-details class="ma-0 pa-0"></v-checkbox>
          </td>
          <td class="text-no-wrap">
            <span>{{ creditorMap[props.item.creditor_id] || "-" }}</span>
          </td>

          <!-- Sender -->
          <td
            style="height: 80px !important"
            class="d-flex align-center whatsapp-senders text-no-wrap"
          >
            <v-layout
              d-flex
              column
              style="max-width: fit-content"
              v-if="props.item.sender"
            >
              <span
                class="text-no-wrap d-flex flex-row align-center"
                style="width: min-content"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      class="d-flex flex-row align-center"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        size="10"
                        :color="
                          props.item.sender.active ? '#4caf50' : '#f44336'
                        "
                      >
                        mdi-circle
                      </v-icon>
                      <span
                        class="d-inline-block caption text-xs-left grey--text text--darken-1"
                        style="width: 24px"
                      >
                        #{{ props.item.sender.id }}
                      </span>
                    </span>
                  </template>
                  {{ props.item.sender.active ? "Ativo" : "Inativo" }}
                </v-tooltip>
                <b class="mr-1">
                  {{ props.item.sender.phone_number | phoneNumber }}
                </b>
                <FlaggedIcon
                  v-if="
                    props.item.sender.meta_status &&
                    props.item.sender.meta_status === 'FLAGGED'
                  "
                ></FlaggedIcon>
                <QualityChip
                  v-if="props.item.sender.meta_quality_rating_v2"
                  :quality="props.item.sender.meta_quality_rating_v2"
                  tooltip="Qualidade do sender"
                  size="small"
                />
              </span>

              <OwnerChip :owner="props.item.sender.owner"></OwnerChip>
            </v-layout>

            <span v-else>-</span>
          </td>

          <!-- Nome/Chave -->
          <td>
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span
                    v-on="on"
                    class="font-weight-bold"
                    :inner-html.prop="props.item.name | highlightText(searchValue)">
                  </span>
                </template>
                <span>id: {{ props.item.id }}</span>
              </v-tooltip>
              <v-tooltip bottom v-if="props.item.type === 'FLOW'">
                <template v-slot:activator="{ on }">
                  <img 
                    v-on="on"
                    src="/img/icons/flow-icon.svg" 
                    alt="Flow"
                    style="width: 20px; height: 20px; margin-left: 4px; vertical-align: middle;"
                  />
                </template>
                <span>Template tipo FLOW</span>
              </v-tooltip>
              <br />
              <div style="display: flex; align-items: center; gap: 4px;">
                <span
                  :inner-html.prop="props.item.key | highlightText(searchValue)">
                </span>
                <v-tooltip bottom v-if="props.item.scope === 'INCENTIVE'">
                  <template v-slot:activator="{ on }">
                    <v-icon size="16" color="orange" v-on="on">mdi-information-outline</v-icon>
                  </template>
                  <span>Template somente para incentivos</span>
                </v-tooltip>
              </div>
              <ApprovalIcon
                :approved="props.item.approved"
                :approvedBy="props.item.approved_by"
                :approvedAt="props.item.approved_at"
              ></ApprovalIcon>
            </div>
          </td>
          <td @click="openPreviewInitiative(props.item)">
            <v-tooltip bottom :disabled="!props.item.description && (!props.item.vars || !props.item.vars.length)">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on" style="cursor: pointer">
                  <span
                    class="two-lines-clamp"
                    :inner-html.prop="props.item.message | highlightText(searchValue)"
                  ></span>
                </div>
              </template>
              <div>
                <p>{{ props.item.description || "" }}</p>
                <p v-if="props.item.vars && props.item.vars.length">
                  Variáveis: {{ props.item.vars.join(", ") }}
                </p>
              </div>
            </v-tooltip>
          </td>
          <td>
            <span
              v-if="props.item.meta_category"
              :inner-html.prop="
                props.item.meta_category | whatsappTemplateCategory | highlightText(searchValue)
              "></span>
            <span v-else>-</span>
          </td>
          <td class="whatsapp-templates">
            <span v-if="props.item.meta_status" class="status" :class="[props.item.meta_status]">
              {{ props.item.meta_status | whatsappTemplateStatus }}
            </span>
            <span v-else>-</span>
          </td>
          <td class="whatsapp-templates">
            <span
              v-if="props.item.meta_quality_score"
              class="status"
              :class="[props.item.meta_status, props.item.meta_quality_score]">
              {{ props.item.meta_quality_score | whatsappTemplateQuality }}
            </span>
            <span v-else>-</span>
          </td>

          <td>
            <v-tooltip bottom v-if="props.item.meta_changed_status_reason" color="warning">
              <template v-slot:activator="{ on }">
                <v-icon color="warning" v-on="on">warning</v-icon>
              </template>
              <span>{{ props.item.meta_changed_status_reason }}</span>
            </v-tooltip>
          </td>
          <td>
            <span class="font-weight-bold">{{ props.item.updated_by }}</span>
            <br />
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on" class="text-no-wrap">{{ props.item.updated_at | formatDateTime }}</span>
              </template>
              <span>{{ props.item.updated_at | formatDateAgo }}</span>
            </v-tooltip>
          </td>
          <td>
            <v-menu bottom left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-tile
                  v-if="showDeactivatedsAux === false"
                  @click="openEditInitiative(props.item)">
                  <v-icon left>mdi-pencil</v-icon>
                  <span>Editar</span>
                </v-list-tile>

                <v-list-tile
                  v-if="isContentApprover && props.item.approved !== true"
                  @click="openApproveInitiative(props.item)">
                  <v-icon left>mdi-check-circle-outline</v-icon>
                  <span>Aprovar</span>
                </v-list-tile>

                <v-list-tile
                  v-if="isContentApprover && props.item.approved === true"
                  @click="confirmDisapproval(props.item)">
                  <v-icon left>mdi-cancel</v-icon>
                  <span>Desaprovar</span>
                </v-list-tile>

                <v-list-tile @click="syncTemplateWithMeta(props.item)">
                  <v-icon left>mdi-sync</v-icon>
                  <span>Sync (meta)</span>
                </v-list-tile>

                <v-divider class="ma-0"></v-divider>

                <v-list-tile @click="handleActivateOrDeactivate([props.item])">
                  <v-icon left>mdi-power</v-icon>
                  <span>{{ props.item.active == true ? "Desativar" : "Ativar" }}</span>
                </v-list-tile>

                <v-divider class="ma-0"></v-divider>

                <v-list-tile @click="handleCopyJson(props.item)">
                  <v-icon left>mdi-content-copy</v-icon>
                  <span>Copiar JSON</span>
                </v-list-tile>

                <v-divider class="ma-0" v-if="canCloneInitiative(props.item)"></v-divider>

                <v-tooltip left :disabled="props.item.approved">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-list-tile
                        v-if="canCloneInitiative(props.item)"
                        @click="openCloneInitiative(props.item)"
                        :disabled="!props.item.approved"
                      >
                        <v-icon left>mdi-content-duplicate</v-icon>
                        <span>Clonar iniciativa</span>
                      </v-list-tile>
                    </div>
                  </template>
                  <span>Aprovação pendente</span>
                </v-tooltip>
              </v-list>
            </v-menu>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-btn color="accent" fixed bottom right fab @click="openNewInitiative()">
      <v-icon>add</v-icon>
    </v-btn>

    <NewInitiative
      :phone_senders="phone_senders"
      :newInitiativeDialog.sync="newInitiativeDialog"
      :creditors.sync="creditors"
      :isContentApprover="isContentApprover"
      @autoapprove="handleAutoApprove" />

    <CloneInitiative
    :cloneInitiativeDialog.sync="cloneInitiativeDialog"
    :creditors="creditors"
    :phone_senders="phone_senders"
    />

    <InitiativePreview ref="initiativePreview" :previewDialog.sync="previewDialog">
    </InitiativePreview>

    <ApproveDialog
      v-model="approveInitiativeDialog" 
      :initiative="approveInitiativeSelected"
      :loading="loading"
      @approve="handleApproval($event, true)"
      @close="handleCloseApproveDialog"
    />

    <AutoApproveDialog
      v-model="autoApprovedDialog"
      :initiative="approveInitiativeSelected"
      @review="handleReviewAutoApprove()"
    />

    <confirmDialog
      v-model="dialogConfirm"
      title="Desaprovar Iniciativa"
      :description="confirmText"
      confirm-text="Desaprovar"
      cancel-text="Cancelar"
      @confirm="disapproveInitiative()"
      @cancel="closeConfirmDialog()"
    />

    <v-snackbar v-model="showSnack" :timeout="2000" top>
      {{ snackMessage }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

//components
import NewInitiative from "./components/NewInitiative";
import CloneInitiative from "./components/CloneInitiative";
import InitiativePreview from "./components/Preview/Preview";
import ApproveDialog from "./components/ApproveDialog";
import AutoApproveDialog from "./components/AutoApproveDialog.vue";

//global components
import SelectCreditors from "@/components/creditor/SelectCreditors";
import SenderSelector from "@/components/senderSelector.vue";
import ApprovalIcon from "@/components/ui/ApprovalIcon.vue";
import FlaggedIcon from "@/components/ui/FlaggedIcon.vue";
import QualityChip from "@/components/ui/QualityChip.vue";
import ConfirmDialog from "@/components/dialogs/ConfirmDialog.vue";
import OwnerChip from "@/components/ui/OwnerChip.vue";

//services
import WhatsAppService from "@/services/whatsapp";
import PhoneSenderService from "@/services/consolidation-tree/phone-senders";


export default {
  components: {
    SelectCreditors,
    NewInitiative,
    CloneInitiative,
    InitiativePreview,
    SenderSelector,
    ApproveDialog,
    ApprovalIcon,
    FlaggedIcon,
    OwnerChip,
    QualityChip,
    ConfirmDialog,
    AutoApproveDialog,
  },
  data() {
    return {
      searchValue: null,
      searchTimer: null,
      showDeactivatedsAux: false,
      loading: false,
      newInitiativeDialog: false,
      autoApprovedDialog: false,
      approveInitiativeDialog: false,
      approveInitiativeSelected: null,
      cloneInitiativeDialog: false,
      previewDialog: false,
      phone_senders: [],
      confirmText: "",
      dialogConfirm: false,
      pagination: {
        rowsPerPage: 25,
        page: 1,
        sortBy: "-updated_at",
        descending: true,
      },
      headers: [
        { text: "", value: "checkbox", width: "5%", sortable: false },
        { text: "Credor", value: "creditor_id", width: "8%", sortable: false },
        { text: "Sender", value: "phone_sender_id", width: "15%", sortable: true },
        { text: "Nome/Chave", value: "name_key", width: "20%", sortable: false },
        { text: "Mensagem", value: "message", width: "22%", sortable: false },
        { text: "Categoria", value: "meta_category", width: "5%", sortable: true },
        { text: "Status", value: "meta_status", width: "5%", sortable: true },
        { text: "Qualidade", value: "meta_quality_score", width: "5%", sortable: true },
        { text: "", value: "meta_changed_status_reason", width: "5%", sortable: false },
        { text: "Atualizado por", value: "updated_at", width: "5%", sortable: true },
        { text: "", value: "menu", width: "5%", sortable: false },
      ],
      metaCategoryAux: null,
      categories: [
        { name: "Marketing", value: "MARKETING" },
        { name: "Utility", value: "UTILITY" },
      ],
      selectedInitiativesUpdate: [],
      selectAllCheckbox: false,
      unselectInitiatives: false,
      creditors: [],
      loadingSenders: false,
      loadingSendersError: false,
      senderAux: null,
      senders: [],
      showSnack: false,
      snackMessage: "",
      approvedAux: null,
      templates: [
        { name: "Todos", value: null },
        { name: "Aprovados", value: true },
        { name: "Não aprovados", value: false },
      ],
      isSyncingSelection: false,
    };
  },
  created() {
    this.clearSelectedInitiative();
    this.getSenders();

    const query = {
      ...this.getCurrentParams(),
      ...this.$route.query,
    };

    this.applyQuery(query);

    this.getInitiatives(query);

    this.getPhoneSenders().then((response) => {
      this.phone_senders = response.objects;
    });
  },
  computed: {
    creditorMap() {
      const map = {};
      if (this.$refs.creditorComponent.creditors) {
        this.$refs.creditorComponent.creditors.forEach((c) => {
          map[c.creditor_id] = `#${c.creditor_id} - ${c.name}`;
        });
      }
      return map;
    },

    isContentApprover() {
      return (
        this.$store.getters.getLoggedUser.roles.includes("content_approver") ||
        this.$store.getters.getLoggedUser.roles.includes("admin")
      );
    },

    ...mapGetters("initiativeManager", {
      error: "error",
      initiaveLoading: "initiaveLoading",
      initiativesList: "initiativesList",
      selectedInitiative: "selectedInitiative",
      selectedCreditor: "selectedCreditor",
      metaCategory: "metaCategory",
      sender: "sender",
      search: "search",
      approved: "approved",
      totalInitiatives: "totalInitiatives",
      showDeactivateds: "showDeactivateds",
    }),
    filteredInitiatives() {
      if (!Array.isArray(this.initiativesList)) {
        return [];
      }
      return this.initiativesList;
    },
  },

  methods: {
    ...mapActions("initiativeManager", {
      getAllInitiatives: "getAllInitiatives",
      editInitiative: "editInitiative",
      syncTemplate: "syncTemplate",
      saveApproval: "saveApproval",
      canAutoApproveInitiative: "canAutoApproveInitiative",
      activateOrDeactivateInitiative: "activateOrDeactivateInitiative",
    }),

    ...mapMutations("initiativeManager", {
      setSelectedCreditor: "setSelectedCreditor",
      setShowDeactivateds: "setShowDeactivateds",
      setMetaCategory: "setMetaCategory",
      setSender: "setSender",
      setSearch: "setSearch",
      setApproved: "setApproved",
      setSelectedInitiative: "setSelectedInitiative",
      clearSelectedInitiative: "clearSelectedInitiative",
    }),

    getPhoneSenders() {
      return PhoneSenderService.listPhoneSenders();
    },

    setCreditors(creditors) {
      this.creditors = creditors;
    },
    handleCopyJson(initiative) {
      const json = JSON.stringify(initiative, null, 2);
      navigator.clipboard.writeText(json).then(
        () => {
          this.snackMessage = "JSON copiado para a área de transferência!";
          this.showSnack = true;
        },
        () => {
          this.snackMessage = "Falha ao copiar o JSON.";
          this.showSnack = true;
        }
      );
    },
    handleActivateOrDeactivate(initiatives) {
      const filters = {
        selectedCreditor: this.selectedCreditor,
        searchInitiative: this.searchInitiative,
        selectedCategories: this.selectedCategories,
        deactivatedInitiatives: this.deactivatedInitiatives,
      };
      this.activateOrDeactivateInitiative({ initiatives, filters });
    },
    fill(val, search) {
      if (typeof val !== "object" && !Array.isArray(val)) {
        return String(val).includes(String(search));
      }
      return false;
    },
    openNewInitiative() {
      this.setSelectedInitiative({
        updated_by: this.$store.getters.getLoggedUser.name,
        meta_status: "APPROVED",
      });
      this.newInitiativeDialog = true;
    },
    openApproveInitiative(initiative) {
      this.approveInitiativeSelected = initiative;
      this.approveInitiativeDialog = true;
    },
    openAutoApprovedDialog(initiative) {
      this.approveInitiativeSelected = initiative;
      this.autoApprovedDialog = true;
    },
    handleCloseApproveDialog() {
      this.approveInitiativeDialog = false;
      this.approveInitiativeSelected = null;
    },
    handleApproval(initiative, approved) {
      const param = {
        id:initiative.id,
        approved,
      };
      this.saveApproval(param);
    },
    confirmDisapproval(initiative) {
      this.confirmText = `Tem certeza que deseja desaprovar o template da iniciativa "${initiative.name}"?`;
      this.dialogConfirm = true;
      this.approveInitiativeSelected = initiative;
    },
    closeConfirmDialog() {
      this.dialogConfirm = false;
      this.approveInitiativeSelected = null;
    },
    disapproveInitiative() {
      if (!this.approveInitiativeSelected) return;

      const param = {
        id: this.approveInitiativeSelected.id,
        approved: false,
      };

      this.saveApproval(param);
      this.dialogConfirm = false;
      this.approveInitiativeSelected = null;
    },
    openEditInitiative(initiative) {
      let mappedButtons = [];

      if (initiative.buttons) {
        if (Array.isArray(initiative.buttons)) {
          mappedButtons = initiative.buttons.map((b) => {
            if (b.link_type) b.type = "URL";
            else b.type = "QUICK_REPLY";
            return b;
          });
        } else {
          mappedButtons.push({
            ...initiative.buttons,
            type: initiative.buttons.link_type ? "URL" : "QUICK_REPLY",
          });
        }
      }

      this.setSelectedInitiative({
        ...initiative,
        buttons: mappedButtons || initiative.buttons,
        updated_by: this.$store.getters.getLoggedUser.name,
      });
      this.newInitiativeDialog = true;
    },
    openCloneInitiative(initiative) {
      let mappedButtons = [];

      if (initiative.buttons) {
        if (Array.isArray(initiative.buttons)) {
          mappedButtons = initiative.buttons.map((b) => {
            if (b.link_type) b.type = "URL";
            else b.type = "QUICK_REPLY";
            return b;
          });
        } else {
          mappedButtons.push({
            ...initiative.buttons,
            type: initiative.buttons.link_type ? "URL" : "QUICK_REPLY",
          });
        }
      }

      const clonedInitiative = {
        ...initiative,
        buttons: mappedButtons || initiative.buttons,
        updated_by: this.$store.getters.getLoggedUser.name,
      };

      this.setSelectedInitiative(clonedInitiative);

      this.cloneInitiativeDialog = true;
    },

    openPreviewInitiative(initiative) {
      this.setSelectedInitiative(initiative);
      this.previewDialog = true;
    },
    canCloneInitiative(initiative) {
      // Verifica se o usuário tem a role para clonar
      const hasQARole = this.$store.getters.isQA;
      const hasWppTemplateAdminRole = this.$store.getters.isWppTemplateAdmin;
      if (!hasWppTemplateAdminRole && !hasQARole) return false;

      return initiative.header_type === 'IMAGE' || initiative.header_type === null;
    },
    getSenders() {
      if (this.loadingSenders) return;

      this.loadingSenders = true;
      this.loadingSendersError = false;

      WhatsAppService.getSenders()
        .then((response) => {
          this.senders = response.objects;

          // Ordena pelo número do remetente
          this.senders.sort((a, b) => {
            if (a.phone_number < b.phone_number) return -1;
            if (a.phone_number > b.phone_number) return 1;
            return 0;
          });
        })
        .catch((error) => {
          console.error("Não foi possível buscar os remetentes do WhatsApp", error);
          this.loadingSendersError = true;
        })
        .finally(() => {
          this.loadingSenders = false;
        });
    },

    async getInitiatives(obj) {
      if (this.initiaveLoading) return;
      const params = obj ? obj : this.getCurrentParams();
      await this.getAllInitiatives(params);
      this.pushQueryInUrl(params);
    },

    getCurrentParams() {
      let params = {
        //pagination
        page: this.pagination.page || 1,
        limit: this.pagination.rowsPerPage || 25,
        order:
          !this.pagination.descending && this.pagination.sortBy
            ? "-" + this.pagination.sortBy
            : this.pagination.sortBy || "",
        //filters
        phone_sender_id: this.sender || "",
        creditor: this.selectedCreditor || "",
        search: this.searchValue || this.search,
        meta_category: this.metaCategory || "",
        active: !this.showDeactivatedsAux,
      };

      if (this.approvedAux !== null) {
        params.approved = this.approved;
      }

      Object.keys(params).forEach((k) => {
        if (!['active', 'approved'].includes(k) && !params[k]) delete params[k];
      });

      return params;
    },

    pushQueryInUrl(obj) {
      const newQuery = { ...obj };
      for (const key in newQuery) {
        const val = newQuery[key];
        if (val === null || val === undefined || String(val) === "NaN") delete newQuery[key];
      }
      this.$router.push({ query: newQuery });
    },

    applyQuery(query) {
      if (query.search) {
        this.searchValue = query.search;
        this.setSearch(query.search);
      }

      if (query.creditor) this.setSelectedCreditor(query.creditor);

      if (query.meta_category) {
        this.setMetaCategory(query.meta_category);
        this.metaCategoryAux = query.meta_category;
      }

      if (query.phone_sender_id) {
        this.setSender(query.phone_sender_id);
        this.senderAux = parseInt(query.phone_sender_id);
      }

      if (query.active) {
        this.setShowDeactivateds(false);
        this.showDeactivatedsAux = false;
      } else {
        this.setShowDeactivateds(true);
        this.showDeactivatedsAux = true;
      }

      if (query.approved !== undefined) {
        const approved = query.approved === "true" ? true : query.approved === "false" ? false : null;
        this.setApproved(approved);
        this.approvedAux = approved;
      }

      if (query.show_deactivateds) {
        const show = query.show_deactivateds === "true";
        this.showDeactivatedsAux = show;
        this.setShowDeactivateds(show);
      }

      if (this.$route.query.order) {
        const descending = !this.$route.query.order.startsWith("-");
        this.pagination.descending = descending;
        this.pagination.sortBy = descending
          ? this.$route.query.order
          : this.$route.query.order.slice(1);
      }
    },

    handleActivateOrDeactivate(initiatives) {
      this.activateOrDeactivateInitiative({ initiatives });
    },

    handleSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.pagination.page = 1;
        this.setSearch(this.searchValue);
        this.getInitiatives();
      }, 500);
    },
    handleCreditor(creditor) {
      this.pagination.page = 1;
      this.setSelectedCreditor(creditor);
      this.getInitiatives();
    },
    handleCategory(category) {
      this.pagination.page = 1;
      this.setMetaCategory(category);
      this.getInitiatives();
    },
    handleSender(sender) {
      this.pagination.page = 1;
      this.setSender(sender);
      this.getInitiatives();
    },
    handleApproved(approved) {
      this.pagination.page = 1;
      this.setApproved(approved);
      this.getInitiatives();
    },
    handleDeactivated(deactivatedOnly) {
      this.pagination.page = 1;
      this.setShowDeactivateds(deactivatedOnly);
      this.getInitiatives();
    },

    async syncSelected(selectedInitiatives = []) {
      if (!selectedInitiatives.length) return;
      try {
        const promises = selectedInitiatives.map(initiative =>
          this.syncTemplateWithMeta(initiative, false)
        );

        const results = await Promise.allSettled(promises);
        const failures = results.filter(r => r.status === 'rejected');
        if (failures.length) {
          console.error(`${failures.length} iniciativas falharam na sincronização. Tente novamente.`, failures);
          this.snackMessage = `Aviso: ${failures.length} iniciativa(s) não pôde(eram) ser sincronizada(s).`;
          this.showSnack = true;
        }

        await this.getInitiatives();
      } catch (error) {
        console.error('Erro crítico ao sincronizar iniciativas:', error);
        this.snackMessage = 'Erro inesperado ao sincronizar.';
        this.showSnack = true;
      }
    },

    async syncTemplateWithMeta(item, updateInitiatives = true) {
      let metaId = item.meta_id;

      if (!metaId && item.meta_structure && item.meta_structure.id) {
        metaId = item.meta_structure.id;
      }

      if (!metaId) {
        this.snackMessage = "Iniciativa ainda não possui ID para sincronizar.";
        this.showSnack = true;
        return;
      }

      try {
        await this.syncTemplate(metaId);
        if (updateInitiatives) await this.getInitiatives();
      } catch (error) {
        console.error("Erro ao sincronizar template com Meta:", error);
        this.snackMessage = "Erro ao sincronizar template com Meta.";
        this.showSnack = true;
      }
    },

    async handleAutoApprove(initiative) {
      try {
        // sincronizar com a meta para atualizar o meta_structure
        await this.syncTemplateWithMeta(initiative, false);

        // recarrega iniciativas voltando pra pagina 1
        this.pagination.page = 1;
        this.pagination.descending = true;
        this.pagination.sortBy = "-updated_at";
        await this.getInitiatives();

        // busca a iniciativa com a meta_structure atualizada
        const syncedInitiative = this.initiativesList.find(
          (ini) => ini.id === initiative.id,
        );
        if (!syncedInitiative) return;
        this.setSelectedInitiative(syncedInitiative);

        // se o usuário tiver permissão para aprovar, verificamos se foi approvado automaticamente.
        // Se sim, abrimos o modal de auto aprovação, senão, abrimos o modal de aprovação normal.
        if (this.isContentApprover) {
          const approved = await this.canAutoApproveInitiative();

          if (approved) {
            await this.handleApproval(syncedInitiative, true);
            this.openAutoApprovedDialog(syncedInitiative);
          } else {
            this.openApproveInitiative(syncedInitiative);
          }
        }
      } catch (error) {
        console.error("Erro no auto approve handler:", error);
      }
    },

    async handleReviewAutoApprove() {
      try {
        await this.handleApproval(this.selectedInitiative, false);
        this.openApproveInitiative(this.selectedInitiative);
      } catch (error) {
        console.error("Erro ao revisar auto aprovação:", error);
      }
    },  
  },
  watch: {
    previewDialog(newValue) {
      if (newValue == false) {
        this.clearSelectedInitiative();
      }
    },
    selectedInitiativesUpdate() {
      if (this.isSyncingSelection) {
        return;
      }

      if (!Array.isArray(this.selectedInitiativesUpdate)) {
        return;
      }

      const selectedLength = this.selectedInitiativesUpdate.length;
      const filteredLength = this.filteredInitiatives.length;

      if (selectedLength < filteredLength) {
        this.selectAllCheckbox = false;
        this.unselectInitiatives = true;
        return;
      }

      if (selectedLength === filteredLength && filteredLength > 0) {
        this.selectAllCheckbox = true;
        this.unselectInitiatives = false;
      }
    },

    selectAllCheckbox(newVal) {
      if (this.isSyncingSelection) {
        return;
      }

      this.isSyncingSelection = true;

      if (newVal) {
        this.selectedInitiativesUpdate = this.filteredInitiatives.slice();
        this.unselectInitiatives = false;
      } else if (this.unselectInitiatives) {
        this.unselectInitiatives = false;
      } else {
        this.selectedInitiativesUpdate = [];
      }

      this.$nextTick(() => {
        this.isSyncingSelection = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.qj-checkbox {
  margin: 25px 0px 0px 0px !important;
  flex: unset !important;
}

.two-lines-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.inactive-row {
  opacity: 0.6;
  background-color: #f5f5f5;
}
</style>